import { TextInput } from '@src/common/components/TextInput';
import type { SearchPermitFilters } from '@src/permits/services/PermitApplicationClient';
import { useTranslation } from 'react-i18next';

export interface Props {
  onFilterChange: (filters: SearchPermitFilters) => void;
  value?: string;
}
export const PONumberFilter = ({ onFilterChange, value }: Props) => {
  const { t } = useTranslation();

  return (
    <TextInput
      label={t('permitSearch.PONumber')}
      value={value}
      onChange={(e) => {
        onFilterChange({
          poNumber: e.target.value as string,
        });
      }}
    />
  );
};
